import API from "../api";
export default {
  namespaced: true,
  state: {
    users: { total_count: 0, items: [] },
    loggedUser: null
  },
  mutations: {
    setUsers(state, data) {
      state.users = data;
    },
    setLoggedUser(state, data) {
      state.loggedUser = data;
    },
    getLoggedUser(state) {
      return state.loggedUser;
    }
  },
  actions: {
    async requestAreaSuggestion() {
      const { data } = await API.getAreaSuggestion();
      return data;
    },
    async requestUserList({ commit }, payload) {
      const { data } = await API.getUserList(payload);
      commit("setUsers", data);
      return data;
    },
    async requestUserSuggestions() {
      const { data } = await API.getUserSuggestions();
      return data;
    },
    async requestUser({ commit }, { userId }) {
      const { data } = await API.getUser(userId);
      commit("setLoggedUser", data);
      return data;
    },
    async editUser(context, { userId, payload }) {
      const { data } = await API.putUser({ userId, payload });
      return data;
    },
    async createUser(context, payload) {
      const { data } = await API.postUser(payload);
      return data;
    },
    async requestEconomicGroupSuggestions(context, payload) {
      const { data } = await API.getEconomicGroupSuggestions(payload);
      return data;
    },
    async requestUserWallet(context, { userId }) {
      const { data } = await API.getUserWallet(userId);
      return data;
    },
    async transferUserWallet(context, { userId, payload }) {
      const { data } = await API.putUserWalletTransfer({ userId, payload });
      return data;
    },
    async requestOfficeSuggestions(context, payload) {
      const { data } = await API.getOfficeSuggestions(payload);
      return data;
    },
    async requestTypeProfiles() {
      const { data } = await API.getTypeProfiles();
      return data;
    }
  },
  modules: {}
};
